/* eslint-disable react/no-unused-prop-types */
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

type TReadingType = 'normalReadings' | 'riskReadings' | 'totalReadings';
interface CountItemProps {
  type: TReadingType;
  value: number;
}

const readingTypeMap: Record<TReadingType, string> = {
  normalReadings: 'Normal',
  riskReadings: 'At Risk',
  totalReadings: 'Total',
};

const CountItem: FC<CountItemProps> = ({ type, value }) => (
  <div className={s['count-item']}>
    <p>{readingTypeMap[type]}</p>
    <span>{value}</span>
  </div>
);

interface ReadingCounterProps {
  normalReadings?: number;
  riskReadings?: number;
  totalReadings?: number;
}

const ReadingCounter: FC<ReadingCounterProps> = ({
  normalReadings = 0,
  riskReadings = 0,
  totalReadings = 0,
}) => {
  const { t } = useTranslation();
  const items = Object.entries({
    normalReadings,
    riskReadings,
    totalReadings,
  }) as [TReadingType, number][];

  return (
    <div className={s['counter-wrapper']}>
      <p className={s['counter-title']}>{t('labels.grandTotal')}:</p>
      <div className={s['count-item-wrapper']}>
        {items.map(([type, value]) => (
          <CountItem key={type} type={type} value={value} />
        ))}
      </div>
    </div>
  );
};
export default ReadingCounter;
